exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parts-finder-modal[data-v-0c36a6f4]{\n  max-width:100%;\n  width:320px\n}", ""]);

// exports
